import { lazy, Suspense, useState } from 'react';
import { Box, Tabs, Tab, Grid, CircularProgress } from '@mui/material';

const Geclisa = lazy(() => import('./Geclisa/Geclisa.jsx'));

export default function Onboarding() {
  const [value, setValue] = useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const tabsConfig = [{ label: 'GECLISA', component: <Geclisa /> }];

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 1, mb: 2, p: 3, boxShadow: 2, borderRadius: 2 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="nav tabs example"
        variant="scrollable"
        scrollButtons="auto"
        TabIndicatorProps={{ style: { background: 'yellow' } }}
      >
        {tabsConfig.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
      <Grid container style={{ marginTop: '23px' }}>
        <Suspense
          fallback={
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <CircularProgress />
            </Box>
          }
        >
          {tabsConfig[value].component}
        </Suspense>
      </Grid>
    </Box>
  );
}
